/**
 * Any changes in `Resource` MUST be applied to core/services/acl.py as well
 */
export enum Resource {
    TESTING = 'testing',
    NO_HOME_AREA = 'no_home_area',
    MAP_DEV_APPS = 'map_dev_apps',
    MAP_COMPS_BROKER_LISTINGS = 'map_comps_broker_listings',
    MAP_COMPS_PARAGON_RESIDENTIAL = 'map_comps_paragon_residential',
    MAP_COMPS_PARAGON_COMMERCIAL = 'map_comps_paragon_commercial',
    MAP_COMPS_AOIR_LISTINGS = 'map_comps_aoir_listings',
    MAP_COMPS_VIVA_MLS_LISTINGS = 'map_comps_viva_mls_listings',
    MAP_COMPS_PRSCREB_MLS_LISTINGS = 'map_comps_prscreb_mls_listings',
    MAP_PLACES_BUSINESS_LICENCES = 'map_places_business_licences',
    UPGRADE_TO_AUTOPROP_PRO = 'upgrade_to_autoprop_pro',
    UPGRADE_NOTIF = 'upgrade_notif',
    UPGRADE_NOTIF_AREA = 'upgrade_notif_area',
    UPGRADE_NOTIF_FOLDER = 'upgrade_notif_folder',
    ATTACHMENTS = 'attachments',
    MAP_LAND_USE_SEARCH = 'map_land_use_search',
    MAP_ZONE_SEARCH = 'map_zone_search',
    EXPORT_KML = 'export_kml',
    MANUAL_PID = 'manual_pid',
    APP_IBOMB = 'app_ibomb',
    APP_CMA = 'app_cma',
    APP_HAS_ADVANCED_SKILLS_CENTRE_ACCESS = 'app_has_advanced_skills_centre_access',
    APP_HAS_BILLING_ACCESS = 'app_has_billing_access',
    APP_HAS_SITEFINDER_ACCESS = 'app_has_sitefinder_access',
    APP_HAS_SITEFINDER_FULL_ACCESS = 'app_has_sitefinder_full_access',
    APP_HAS_SKILLS_CENTRE_ACCESS = 'app_has_skills_centre_access',
    APP_IS_REBGV_MEMBER = 'app_is_rebgv_member',
    APP_IS_VREB_MEMBER = 'app_is_vreb_member',
    APP_IS_VIREB_MEMBER = 'app_is_vireb_member',
    APP_IS_FVREB_MEMBER = 'app_is_fvreb_member',
    APP_IS_CADREB_MEMBER = 'app_is_cadreb_member',
    APP_IS_BCNREB_MEMBER = 'app_is_bcnreb_member',
    APP_IS_PRSCREB_MEMBER = 'app_is_prscreb_member',
    APP_SHOW_BUNDLES_INFO = 'app_show_bundles_info',
    REPORT_DS_AOIR_COMPARABLES = 'ds_aoir_comparables',
    REPORT_DS_PARAGON_RESIDENTIAL = 'ds_paragon_residential',
    REPORT_DS_PARAGON_COMMERCIAL = 'ds_paragon_commercial',
    REPORT_DS_PARAGON_COMMERCIAL_HISTORY_DETAIL = 'ds_paragon_commercial_history_detail',
    REPORT_DS_VIVA_MLS_COMPARABLES = 'ds_viva_mls_comparables',
    REPORT_DS_VIVA_MLS_TAX_REPORT = 'ds_viva_mls_tax_report',
    REPORT_DS_COMMERCIAL_EDGE = 'ds_commercial_edge',
    REPORT_DS_LTSA = 'ds_ltsa',
    REPORT_DS_PRSCREB_MLS = 'ds_prscreb_mls',
    REPORT_DS_BROKER_LISTINGS = 'ds_broker_listings',
    TABLE_LTSA = 'table_ltsa',
    TABLE_LTSA_OWNERS = 'table_ltsa_owners',
    TABLE_LTSA_EXTRA_FIELDS = 'table_ltsa_extra_fields',
    TABLE_SALES_HISTORY = 'table_sales_history',
    SUMMARY_SHEET_LTSA = 'summary_sheet_ltsa',
    SUMMARY_SHEET_MLS_HISTORY = 'SUMMARY_SHEET_MLS_HISTORY',
    ADMIN_DELETE_USERS = 'ADMIN_DELETE_USERS',
    MAP_VANCOUVER_RENTAL_PP = 'MAP_VANCOUVER_RENTAL_PP',
    MAP_TOA = 'MAP_TOA',
    MAP_TOA52 = 'MAP_TOA52',
    NOTIF_FOLDER_PI = 'NOTIF_FOLDER_PI',
    NOTIF_FOLDER_BL = 'NOTIF_FOLDER_BL',
    NOTIF_AREA_PI = 'NOTIF_AREA_PI',
    NOTIF_AREA_BL = 'NOTIF_AREA_BL',
    NOTIF_AREA_MLS = 'NOTIF_AREA_MLS',
    UPGRADE_OFFERLAND_OFFERRENT = 'UPGRADE_OFFERLAND_OFFERRENT',
    OFFERLAND_OFFERRENT = 'OFFERLAND_OFFERRENT',
    OFFERLAND_STRATA_REPORT = 'OFFERLAND_STRATA_REPORT',
    OFFERLAND_STRATA_REPORT_DISABLED = 'OFFERLAND_STRATA_REPORT_DISABLED',
    OFFERLAND_SUMMARY_SHEET = 'OFFERLAND_SUMMARY_SHEET',
    YODA = 'YODA',
    YODA_CSV = 'YODA_CSV',
    YODA_PROXIMITY = 'YODA_PROXIMITY',
    YODA_REGIONAL_INSIGHT_REPORT = 'YODA_REGIONAL_INSIGHT_REPORT',
}
